/**
 * Assigned `CareCaseStatus.statusID` values.
 *
 * These are *assigned* IDs, not auto-increment — an admin sets them explicitly in
 * `/LookUp/ActsCareCounseling/CaseStatus`. The three below are fixed by the backend contract and are
 * safe to reference directly; the rest (Waiting List, Draft, Rejected, Cancelled…) are site-configurable,
 * which is why `CasesListView` still matches those by name. See `_memory/_context/06-known-issues.md` B6.
 */
export const CASE_STATUS = {
  New: 0,
  Assigned: 1,
  InProgress: 2,
} as const;
